interface Scopes {
  accessAsUser: string;
  pcApiScope: string;
  openid: string;
  profile: string;
  offlineAccess: string;
}

export const scopes: Scopes = {
  accessAsUser: import.meta.env.VITE_ACCESS_AS_USER_SCOPE!,
  pcApiScope: 'https://api.partnercenter.microsoft.com/user_impersonation',
  openid: 'openid',
  profile: 'profile',
  offlineAccess: 'offline_access',
};
